/**
 * ReviewsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import ReviewsContext from './reviews-context'
import { fetchReviewsByProductID, createReview } from './reviews-api'

export default function ReviewsProvider({ children }) {
  const state = {
    fetchReviewsByProductID,
    createReview
  }
  return (
    <ReviewsContext.Provider value={state}>
      {children}
    </ReviewsContext.Provider>
  )
}
